<app-nav></app-nav>
<router-outlet></router-outlet>
<app-footer></app-footer>

<ngx-spinner
  bdColor="#fefefe"
  size="medium"
  color="red"
  class="textMainColor w-full"
  type="square-jelly-box"
  [fullScreen]="true"
>
  <figure>
    <img src="../assets/images/plane loader.gif" alt="loader gif" />
  </figure>
  <!-- <p class="text-capitalize text-center textMainColor fs-2">Loading...</p> -->
</ngx-spinner>

<a [href]="phoneNumber" target="_blank" class="whatsapp-float iconBox cPointer">
  <i class="fa-brands fa-whatsapp"></i>
</a>
